// regular export because Form is already 'dynamic no SSR'
import Form from "./Form";

export default Form;
